import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { joinEarlyAccess } from "../../../utils/services";
const Joinmodal = ({ show, onHide }) => {
  const [showJoined, setShowJoined] = useState(false);
  const handleCloseJoined = () => setShowJoined(false);
  const handleShowJoined = () => setShowJoined(true);

  const [showFailed, setShowFailed] = useState(false);
  const handleCloseFailed = () => setShowFailed(false);
  const handleShowFailed = () => setShowFailed(true);

  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    email: "",
    agreed: false,
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    const newValue = type === "checkbox" ? checked : value;
    setForm({
      ...form,
      [name]: newValue,
    });
    setErrors((prev) => ({
      ...prev,
      [name]: false,
    }));
  };
  const validate = () => {
    let newErrors = {};
    if (!form.firstName.trim()) newErrors.firstName = true;
    if (!form.lastName.trim()) newErrors.lastName = true;
    if (!form.email.trim()) {
      newErrors.email = true;
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) {
      newErrors.email = true;
    }
    if (!form.agreed) newErrors.agreed = true;
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (!validate()) return;
    try {
      setLoading(true);

      await joinEarlyAccess(form);
      setForm({
        firstName: "",
        lastName: "",
        email: "",
        agreed: false,
      });
      setErrors({});

      handleShowJoined();
      onHide();
    } catch (err) {
      handleShowFailed();
    } finally {
      setLoading(false);
    }
  };
  return (
    <>
      <Modal className="join" show={show} onHide={onHide} centered>
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <div className="maincontent">
            <h2>Join Early Access</h2>
            <p>
              Be among the first to explore verified company data on TRAQSTOCK.
              Sign up to receive updates and early platform access.
            </p>
            <div className="maininputs">
              <div className="innerinput">
                <p>First Name </p>
                <input
                  type="text"
                  name="firstName"
                  value={form.firstName}
                  onChange={handleChange}
                  placeholder="Enter your first name"
                  className={errors.firstName ? "error" : ""}
                />
              </div>
              <div className="innerinput">
                <p>Last Name </p>
                <input
                  type="text"
                  name="lastName"
                  value={form.lastName}
                  onChange={handleChange}
                  placeholder="Enter your Last name"
                  className={errors.lastName ? "error" : ""}
                />
              </div>
              <div className="innerinput">
                <p>Email Address</p>
                <input
                  type="text"
                  name="email"
                  value={form.email}
                  onChange={handleChange}
                  placeholder="your@email.com"
                  className={errors.email ? "error" : ""}
                />              </div>
            </div>
            <div className="maincheck">
              <label
                className={`material-checkbox ${errors.agreed ? "checkbox-error" : ""}`}
              >
                <input
                  type="checkbox"
                  name="agreed"
                  checked={form.agreed}
                  onChange={handleChange}
                />
                <span class="checkmark"></span>
              </label>
              I agree to receive updates about
              TRAQSTOCK.
            </div>

            <button
              className="request"
              disabled={loading}
              onClick={handleSubmit}
            >
              {loading ? "Submitting..." : "Request Early Access"}
            </button>
            <div className="brdr"></div>
            <h6>
              Need help accessing your account? <a href="/contact">Contact</a> TRAQSTOCK
              support
            </h6>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        className="join"
        show={showJoined}
        onHide={handleCloseJoined}
        centered
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <div className="maincontent">
            <span className="green">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="40"
                height="40"
                viewBox="0 0 40 40"
                fill="none"
              >
                <path
                  d="M8.3335 23.3333L14.1668 29.1667L31.6668 10.8333"
                  stroke="#10B981"
                  stroke-width="2.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </span>
            <h2>You're on the list!</h2>
            <p>
              Thank you for joining early access. We'll notify you when
              TRAQSTOCK becomes available.
            </p>
            <button
              className="close"
              onClick={() => {
                handleCloseJoined();
              }}
            >
              Close
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal className="join" show={showFailed} onHide={handleCloseFailed} centered>
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <div className="maincontent">
            <span className="red">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="40"
                height="40"
                viewBox="0 0 40 40"
                fill="none"
              >
                <path
                  d="M23.2077 35H16.7917C9.07428 35 5.2156 35 3.79361 32.4898C2.37163 29.9798 4.34528 26.6523 8.29258 19.9975L11.5006 14.5889C15.2923 8.1963 17.1882 5 19.9997 5C22.8112 5 24.707 8.19628 28.4987 14.5889L31.7068 19.9975C35.654 26.6523 37.6277 29.9798 36.2057 32.4898C34.7837 35 30.925 35 23.2077 35Z"
                  stroke="#EF4444"
                  stroke-width="2.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M20 28.3333V20.8333"
                  stroke="#EF4444"
                  stroke-width="2.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M20 14.9971V14.9805"
                  stroke="#EF4444"
                  stroke-width="2.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </span>
            <h2>Submission Failed</h2>
            <p>
              Something went wrong while submitting your request. Please try
              again.
            </p>
            <button
              className="close"
              onClick={() => {
                handleCloseFailed();
              }}
            >
              Try Again
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Joinmodal;
